<template>
  <el-card class="demo-container h-full">
    <div ref="formHeightRef">
      <el-form :inline="true" :model="form" ref="form" @submit.native.prevent="search">
        <el-form-item label="" prop="protocolName">
          <el-input v-model="form.protocolName" placeholder="协议名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="" prop="manufacturerCode">
          <el-select v-model="form.manufacturerCode" placeholder="设备厂商" clearable>
            <el-option
              v-for="item in facturerList"
              :key="item.code"
              :label="item.displayName"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" native-type="submit">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="tableData" border stripe :height="`calc(100vh - 200px - ${formHeight}px)`" v-loading="tableLoading">
      <el-table-column label="协议名称" prop="protocolName" show-overflow-tooltip></el-table-column>
      <el-table-column label="适用厂商" prop="manufacturerCodes" show-overflow-tooltip>
        <template slot-scope="{ row }">
          {{ showFacturerName(row.manufacturerCodes) }}
        </template>
      </el-table-column>
      <el-table-column
        label="类型归属"
        prop="deviceListName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="{ row }">
          <el-button size="mini" :disabled="!$hasAccess('update')" @click.stop="protocolHandle(row)"
            >协议配置</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-20px"
      background
      @size-change="getList"
      @current-change="getList"
      :current-page.sync="initPagination.pageNum"
      :page-size.sync="initPagination.pageSize"
      :total="initPagination.total"
      layout="->,total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
    >
    </el-pagination>

    <ProtocolConfigList
      v-if="protocolConfigShow"
      :show.sync="protocolConfigShow"
      :detailRow="detailRow"
    ></ProtocolConfigList>
  </el-card>
</template>

<script>
import { IOTDeviceTemplateApi } from '@wiz-api/iot-device-management'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import tableHeightMixin from '@/mixins/tableHeightMixin'
import ProtocolConfigList from './protocolConfigList'

const ioTdeviceManagementApi = new IOTDeviceTemplateApi()
const dataCategoryApi = new DataCategoryApi()
export default {
  name: 'monitorProtocol',
  mixins: [tableHeightMixin],
  components: {
    ProtocolConfigList,
  },
  props: {
    // 设备类型编码
    deviceTypeCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      facturerList: [],
      deviceTypeList: [],
      factureMap: {},
      deviceTypeMap: {},
      form: {
        manufacturerCode: '',
        protocolName: '',
      },
      initPagination: {
        pageNum: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],
      tableLoading: false,
      detailRow: {},
      protocolConfigShow: false,
    }
  },
  methods: {
    showFacturerName(manufacturerCodes) {
      const codes = manufacturerCodes.split(',')
      const manufacturerName = []
      codes.forEach((code) => {
        if (this.factureMap[code]) {
          manufacturerName.push(this.factureMap[code])
        }
      })
      return manufacturerName.join()
    },
    protocolHandle(row) {
      this.detailRow = {
        id: row.id,
        protocolTypeCode: row.protocolCode,
        manufacturer: row.manufacturerCodes,
        manufacturerName: this.showFacturerName(row.manufacturerCodes),
        protocolTypeName: row.protocolName,
      }
      this.protocolConfigShow = true
    },
    search() {
      this.initPagination.pageNum = 1
      this.getList()
    },
    reset() {
      this.$refs.form.resetFields()
      this.getList()
    },
    async getList() {
      this.tableLoading = true
      const [err, res] = await ioTdeviceManagementApi.getProtocolList({
        ...this.form,
        SkipCount: 0,
        MaxResultCount: 99,
        deviceTypeCode: this.deviceTypeCode,
      })
      if (!err) {
        res.items.forEach((item) => {
          const deviceList = item.deviceTypeCodes.split(',')
          const deviceListName = []
          deviceList.forEach((deviceCode) => {
            if (this.deviceTypeMap[deviceCode]) {
              deviceListName.push(this.deviceTypeMap[deviceCode])
            }
          })
          item.deviceListName = deviceListName.join()
        })
        this.tableData = res.items
        this.initPagination.total = res.totalCount
      }
      this.tableLoading = false
    },
    // 获取数据字典数据
    async getCategoryByCodes() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: ['IOTDeviceTemplateManufacturer', 'IOTDeviceTemplateDeviceType'],
        includeDetails: true,
      })
      if (!err) {
        let facturerList = []
        let deviceTypeList = []
        res.forEach((item) => {
          if (item.code === 'IOTDeviceTemplateManufacturer') {
            // 设备厂商
            facturerList = item.dataItems
          }
          if (item.code === 'IOTDeviceTemplateDeviceType') {
            // 类型归属
            deviceTypeList = item.dataItems
          }
        })
        this.facturerList = facturerList
        this.deviceTypeList = deviceTypeList
        this.factureMap = facturerList.reduce((map, cur) => {
          map[cur.code] = cur.displayName
          return map
        }, {})
        this.deviceTypeMap = deviceTypeList.reduce((map, cur) => {
          map[cur.code] = cur.displayName
          return map
        }, {})
        this.getList()
      }
    },
  },
  async created() {
    this.getCategoryByCodes()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
